import type {ReactElement} from 'react';

import {i18n} from '@yourcoach/i18n';

import {alert} from '../../../components/alert';

export async function notAllowedAlert(message: string) {
  return await okAlert({
    message,
    title: i18n.t('shared:services.entity_action.common_alert.not_allowed'),
  });
}

export async function okAlert({
  beforeTitleSlot,
  message,
  title,
}: {
  beforeTitleSlot?: () => ReactElement<any>;
  message?: string;
  title: string;
}) {
  return await alert.show<boolean>({
    beforeTitleSlot,
    buttons: [
      {
        label: i18n.t('shared:ok'),
        onAwaitableClick: resolve => resolve(true),
        scheme: 'primary',
      },
    ],
    message,
    title,
  });
}

export async function tryAgainAlert(
  callback: (...args: any) => Promise<unknown>,
): Promise<unknown> {
  const tryAgain = await alert.show<boolean>({
    buttons: [
      {
        label: i18n.t('shared:cancel'),
        onAwaitableClick: resolve => resolve(false),
        scheme: 'gray',
      },
      {
        label: i18n.t('shared:try_again'),
        onAwaitableClick: resolve => resolve(true),
        scheme: 'primary',
      },
    ],
    title: i18n.t('shared:message.error_fix'),
  });

  if (tryAgain) {
    return await callback();
  }
}
